import { postgrestFrom, runPostgrest } from '@/api/postgrest/client'
import { temuProducttypeCategoryRowsSchema } from '@/api/temuProducttypes/schemas'
import type { TemuProducttypeCategory } from '@/api/temuProducttypes/types'

/** Lädt die in der Datenbank hinterlegten Temu-Kategoriezuordnungen. */
export async function fetchTemuProducttypeCategories(
  signal?: AbortSignal,
): Promise<readonly TemuProducttypeCategory[]> {
  let query = postgrestFrom('temu_producttype_categories')
    .select(
      'producttypeKey:producttype_key,categoryId:cat_id,categoryName:cat_name,producttype:producttypes(producttypeName:name)',
    )
    .order('producttype_key', { ascending: true })
  if (signal !== undefined) query = query.abortSignal(signal)

  const rows = await runPostgrest(
    query,
    temuProducttypeCategoryRowsSchema,
    'temu_producttype_categories',
  )

  return rows.map((row) => ({
    producttypeKey: row.producttypeKey,
    producttypeName: row.producttype.producttypeName,
    categoryId: row.categoryId,
    categoryName: row.categoryName,
  }))
}
